$(document).ready(function () {
	let $forms = $('[data-vgformsender]');

	$forms.each(function () {
		enableRecaptchaForForm(this);
	});

	$forms.vegasFormSender({
		beforeSend: function (form, params) {
			AlertFormSender.Action.beforeSend(form, params);
		},
		success: function (data, form, params) {
			if (data.error) {
				if (data.type === 'captcha') {
					AlertFormSender.Action.error(data.msg, form, params);
				} else {
					AlertFormSender.Action.error(data.msg, form, params);
				}
			} else {
				AlertFormSender.Action.success(data.msg, form, params);
			}

			$(form).find('[name=g-recaptcha-response]').val('');
		},
		error: function (msg, form, params) {
			AlertFormSender.Action.error(msg, form, params);
		},
		validate: function (form, params, errors) {
			ValidateFormSender.init(errors, form, params);
		}
	});
});
